module.exports = __webpack_public_path__ + "static/img-blog-funderbeam-2b9ed65bc40358a4e81b052447be8810.png";